import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

export const Route = createFileRoute('/_app/outlet/staff/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PageLayout>
      <PageLayout.Header title='Daftar Karyawan' />
    </PageLayout>
  )
}
